export const TECHNICAL_HELP_CTA_URL =
  "https://www.getclockwise.com/c/rian-dillon-saleor-io/short-call-with-saleor";

export const DOCS_ULRS = {
  TRANSACTIONS_AUTOMATIC_CHECKOUT_COMPLETION:
    "https://docs.saleor.io/developer/payments/transactions#automatic-checkout-completion",
};

export const MISSING_APPS_TYPEFORM_URL = "https://saleor.typeform.com/to/ecR2msLk";

export const PRODUCT_CONFIGURATION_DOCS_URL =
  "https://docs.saleor.io/developer/products/configuration";
export const ORDER_MANAGEMENT_DOCS_URL = "https://docs.saleor.io/developer/checkout/order-status";
export const API_REFERENCE_DOCS = "https://docs.saleor.io/api-reference/";
export const API_GUIDE_DOCS = "https://docs.saleor.io/api-usage/overview";
export const EXTENDING_WITH_WEBHOOKS_DOCS_URL =
  "https://docs.saleor.io/developer/extending/webhooks/overview";
export const USER_PERMISSIONS_DOCS_URL =
  "https://docs.saleor.io/developer/permissions#user-permissions";
